import { useCallback, useEffect, useRef, useState } from 'react';

/** Tracks whether an ATC cell element intersects the viewport (row + column visibility). */
export function useAtcCellInView(): {
  cellRef: (node: HTMLDivElement | null) => void;
  cellInView: boolean;
} {
  const [cellInView, setCellInView] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const cellRef = useCallback((node: HTMLDivElement | null) => {
    if (observerRef.current !== null) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (node === null) {
      setCellInView(false);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setCellInView(entry?.isIntersecting ?? false);
      },
      { threshold: 0, rootMargin: '0px' }
    );
    observer.observe(node);
    observerRef.current = observer;
  }, []);

  useEffect(() => {
    return () => {
      if (observerRef.current !== null) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, []);

  return { cellRef, cellInView };
}
